import { BetaBadge, Button } from '@shared/components';
import clsx from 'clsx';
import { ReactNode } from 'react';
import { PiChats } from 'react-icons/pi';

type ThreadHeaderProps = {
  children?: ReactNode;
  isCompact?: boolean;
  leadingAction?: ReactNode;
  onBack?: () => void;
  trailingAction?: ReactNode;
};

export function ThreadHeader({
  children,
  isCompact = false,
  leadingAction,
  onBack,
  trailingAction,
}: ThreadHeaderProps) {
  return (
    <div
      className={clsx(
        'flex h-14 shrink-0 items-center gap-3 bg-white',
        isCompact ? 'px-3' : 'px-6'
      )}
    >
      {onBack && (
        <Button
          aria-label="All chats"
          isGhost
          icon={<PiChats size={16} />}
          onPress={onBack}
          size="xs"
          tooltip="All chats"
        />
      )}
      {leadingAction}
      {children}
      <BetaBadge className="ml-auto" />
      {trailingAction}
    </div>
  );
}
